interface HeaderSectionProps {
  image: string;
  header: string;
  subHeader: string;
  bgBlack?: number;
}

const HeaderSection: React.FC<HeaderSectionProps> = ({ image, header, subHeader, bgBlack = 5 }) => {
  return (
    <div
      className="relative bg-cover bg-center h-64 flex items-center justify-center"
      style={{
        backgroundImage: `url('${image}')`, // Dynamically set the background image
      }}
    >
      <div className={`absolute inset-0 bg-black/${bgBlack}`}></div>
      <div className="relative z-10 text-center">
        <h1 className="text-3xl sm:text-5xl font-bold text-white">{header}</h1>
        <p className="text-lg text-gray-300 mt-2">{subHeader}</p>
      </div>
    </div>
  );
};

export default HeaderSection;